import Vue from 'vue';
import Router from 'vue-router';

import SitesList from '@/scenes/SitesList';
import SiteDetails from '@/scenes/SiteDetails';
import Navigation from '@/scenes/Navigation';
import FindParkingSpot from '@/scenes/FindParkingSpot';
import store from '@/store';

Vue.use(Router);

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/sites',
      name: 'scene.sites.list',
      component: SitesList,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/site/:id',
      name: 'scene.site.details',
      component: SiteDetails,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/navigation',
      name: 'scene.navigation',
      component: Navigation,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/find-parking-spot',
      name: 'scene.find_parking_spot',
      component: FindParkingSpot,
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (from.name !== to.name) {
    store.dispatch('history/push', to.name);
  }
  if (to.path === '/') {
    // If / path asked -> redirection
    next({ name: 'scene.sites.list' });
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (localStorage.getItem('access_token') === null) {
        store.dispatch('auth/login');
        next();
      } else {
        next();
      }
    } else {
      next();
    }
  }
});

export default router;
